export const environment = {
  production: true,
  host: 'https://test.mytable.costa.it',
  api: '/api',
};
